import { createContext, useMemo, useState } from 'react';
import type { SavedSearch } from '~/contracts/common';

export type SavedSearchesContextType = {
  savedSearches: SavedSearch[];
  setSavedSearches: (savedSearches: SavedSearch[]) => void;
};

const defaultContext: SavedSearchesContextType = {
  savedSearches: [],
  setSavedSearches() {}
};

const SavedSearchesContext =
  createContext<SavedSearchesContextType>(defaultContext);

export function SavedSearchesContextProvider({ children }) {
  const [savedSearches, setSavedSearches] = useState(
    defaultContext.savedSearches
  );

  const value = useMemo<SavedSearchesContextType>(
    () => ({
      savedSearches,
      setSavedSearches
    }),
    [savedSearches, setSavedSearches]
  );

  return (
    <SavedSearchesContext.Provider value={value}>
      {children}
    </SavedSearchesContext.Provider>
  );
}

SavedSearchesContextProvider.displayName = 'SavedSearchesContextProvider';

export default SavedSearchesContext;
